import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Core components
import Box from 'components/core/Box';
import Card from 'components/core/Card';
// Models
import mInstallationAsyncOperation from 'models/installationAsyncOperation';
// Custom
import { getInstallationAsyncOperationsList } from 'actions';
import { installationDataShape, installationAsyncOperationDataShape } from 'constants/PropTypesShapes';
import RowDetailsTemplate from 'components/templates/RowDetailsTemplate';
import SubListTemplate from 'components/templates/SubListTemplate';
import { DisplayListTextButton } from 'components/buttons/TextButtons';
import AsyncOperationRow from 'installations/assets/asyncOperations/AsyncOperationRow';
import { asyncOperationsPath } from 'installations/navigation';

const InstallationRowDetails = ({ installation, asyncOperations, handleGetAsyncOperationsList }) => {
  // Installation async operations
  const { loading, data } = asyncOperations || { loading: true };

  // Handlers
  const handleGetList = (pagination, sort, filters) => {
    _delay(() => {
      handleGetAsyncOperationsList(installation.id, { page: 1, pageSize: 20 }, sort, filters);
    }, 500);
  };

  // Private
  const doGetRowComp = (props) => (
    <AsyncOperationRow
      {...props}
      installationDevices={installation.devices}
    />
  );

  return (
    <RowDetailsTemplate>
      <Box type="defaultBackground" className="p-3">
        <div className="row">
          <div className="col-12">
            <Card
              title={<LocalizedMessage id="title.lastAsyncOperations" />}
              headerAction={
                <DisplayListTextButton primary path={asyncOperationsPath(installation.id)} />
              }
            >
              <div style={{ marginTop: -24 }}>
                <SubListTemplate
                  name={mInstallationAsyncOperation.name}
                  listFeatures={mInstallationAsyncOperation.listFeatures}
                  withQueryParams={false}
                  withBorder={false}
                  elementsData={{
                    loading,
                    elements: {
                      data,
                      totalEntries: _size(data),
                    },
                    handleGetList,
                  }}
                  withPagination={false}
                  withFooter={false}
                  withVirtualization={false}
                  rowComp={doGetRowComp}
                />
              </div>
            </Card>
          </div>
        </div>
      </Box>
    </RowDetailsTemplate>
  );
};

InstallationRowDetails.propTypes = {
  installation: installationDataShape.isRequired,
  asyncOperations: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(installationAsyncOperationDataShape),
  }),
  handleGetAsyncOperationsList: PropTypes.func.isRequired,
};

InstallationRowDetails.defaultProps = {
  asyncOperations: null,
};

const mapStateToProps = (state, ownProps) => ({
  asyncOperations: state.installationAsyncOperation.installations[ownProps.installation.id],
});

const mapDispatchToProps = (dispatch) => ({
  handleGetAsyncOperationsList: (id, pagination, sort, filters, desynchronized) => {
    dispatch(getInstallationAsyncOperationsList(id, pagination, sort, filters, desynchronized));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallationRowDetails);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/main/InstallationRowDetails.js